import { render } from "./ArchivedWallets.vue?vue&type=template&id=0fa0c760&scoped=true"
import script from "./ArchivedWallets.vue?vue&type=script&lang=js"
export * from "./ArchivedWallets.vue?vue&type=script&lang=js"

import "./ArchivedWallets.vue?vue&type=style&index=0&id=0fa0c760&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa0c760"]])

export default __exports__